<template>
    <div class="memberwork-title-box" :class="ready === true ? 'memberwork-animation-ready' : 'memberwork-animation' ">
        <template v-for="(value, index) in titleList" :key="index">
            <cardTitle :avatar="value.avatar" :groupName="value.roomName" :creatorName="value.creatorName" />
        </template>
    </div>
    <span>{{group}}</span>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed} from 'vue'
    import cardTitle from '@/components/cardTitle.vue'
    import chatApi from "@/request/chatApi";

    const { proxy } = getCurrentInstance();

    const props = defineProps(['cardLgoin', 'ready'])

    const titleList = ref([])

    async function getUserinfoGroup(login, callback){
        const request = chatApi.getUserGroupinfo
        const params = request.getParams()

        params.UserLogin = login

        request.send(params, (res) => {
            if (typeof callback === "function"){
                callback(res)
            }
        })

    }

    function getUserinfoGroupCallback(detail) {
        if (null == detail){
            return
        }

        let obj = detail

        if (obj.success == true){
            const list = []
            obj.data.forEach((v, i) => {
                if (v.groupType === 6 && v.isOpenValidityTitles === true){

                    for (let i=0; i<v.users.length; i++){
                        var user = v.users[i]

                        if(user.role == "ADMIN"){
                            v.creatorName = user.username
                            break;
                        }
                    }

                    list.push(v)
                }
            })

            titleList.value = list
        }

    }

    const group = computed(() => {
        if (null != props.cardLgoin && "" !== props.cardLgoin){
           // getUserinfoGroup(props.cardLgoin, getUserinfoGroupCallback)
        }

        return ""
    })
</script>

<style scoped>
    .memberwork-title-box {
        list-style: none;
        margin: auto;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 100%;
        position: relative;
        text-align: left;
        max-width: 500px;
    }

    .memberwork-animation {
        animation: memberworkTransition 1.5s ease;
    }

    @keyframes memberworkTransition {
        0% {
            opacity: 0;
            left: -30vw;
        }

        30% {
            opacity: 0;
            left: -30vw;
        }

        /*60% {*/
        /*    opacity: 0.5;*/
        /*    transform: rotateX(360deg);*/
        /*}*/

        100% {
            opacity: 1;
            left: 0;
        }
    }
</style>